import apiClient from '@services/api/apiClient.jsx';

/**
 * 테마 필터 매핑 API 서비스
 */
const themeFilterMappingApi = {
    /**
     * 테마별 필터 매핑 목록 조회
     */
    getThemeFilterMappings: async (themeId) => {
        try {
            const response = await apiClient.get(`/theme-filter-mappings`, {
                params: { themeId }
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 필터 매핑 목록 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 특정 테마 필터 매핑 조회
     */
    getThemeFilterMapping: async (mappingId) => {
        try {
            const response = await apiClient.get(`/theme-filter-mappings/${mappingId}`);
            return response.data.data;
        } catch (error) {
            console.error('테마 필터 매핑 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 추가 가능한 필터 목록 조회
     */
    getAvailableFilters: async (themeId) => {
        try {
            const response = await apiClient.get(`/theme-filter-mappings/available-filters`, {
                params: { themeId }
            });
            return response.data.data;
        } catch (error) {
            console.error('사용 가능한 필터 목록 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 테마에 필터 추가
     */
    addFilterToTheme: async (themeId, photoFilterId, customImages = {}) => {
        try {
            const formData = new FormData();
            formData.append('themeId', themeId);
            formData.append('photoFilterId', photoFilterId);

            if (customImages.defaultImageResourceId) {
                formData.append('customDefaultImageResourceId', customImages.defaultImageResourceId);
            }
            if (customImages.hoverImageResourceId) {
                formData.append('customHoverImageResourceId', customImages.hoverImageResourceId);
            }
            if (customImages.displayOrder) {
                formData.append('displayOrder', customImages.displayOrder);
            }

            const response = await apiClient.post(`/theme-filter-mappings`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.data;
        } catch (error) {
            console.error('테마에 필터 추가 실패:', error);
            throw error;
        }
    },

    /**
     * 테마 필터 매핑 수정
     */
    updateThemeFilterMapping: async (mappingId, updateData) => {
        try {
            const formData = new FormData();

            if (updateData.customDefaultImageResourceId !== undefined) {
                formData.append('customDefaultImageResourceId', updateData.customDefaultImageResourceId || '');
            }
            if (updateData.customHoverImageResourceId !== undefined) {
                formData.append('customHoverImageResourceId', updateData.customHoverImageResourceId || '');
            }
            if (updateData.displayOrder !== undefined) {
                formData.append('displayOrder', updateData.displayOrder);
            }
            if (updateData.isActive !== undefined) {
                formData.append('isActive', updateData.isActive);
            }

            const response = await apiClient.put(`/theme-filter-mappings/${mappingId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 필터 매핑 수정 실패:', error);
            throw error;
        }
    },

    /**
     * 테마에서 필터 제거
     */
    removeFilterFromTheme: async (mappingId) => {
        try {
            const response = await apiClient.delete(`/theme-filter-mappings/${mappingId}`);
            return response.data.success;
        } catch (error) {
            console.error('테마에서 필터 제거 실패:', error);
            throw error;
        }
    },

    /**
     * 필터 순서 변경
     */
    reorderFilters: async (themeId, mappingOrders) => {
        try {
            const requestData = {
                themeId,
                mappingOrders
            };

            const response = await apiClient.put(`/theme-filter-mappings/reorder`, requestData);
            return response.data.success;
        } catch (error) {
            console.error('필터 순서 변경 실패:', error);
            throw error;
        }
    },

    /**
     * 테마별 필터 매핑 수 조회
     */
    getThemeFilterMappingCount: async (themeId) => {
        try {
            const response = await apiClient.get(`/theme-filter-mappings/count`, {
                params: { themeId }
            });
            return response.data.data;
        } catch (error) {
            console.error('테마 필터 매핑 수 조회 실패:', error);
            throw error;
        }
    },

    /**
     * 필터 중복 체크
     */
    checkFilterDuplicate: async (themeId, photoFilterId) => {
        try {
            const response = await apiClient.get(`/theme-filter-mappings/check-duplicate`, {
                params: { themeId, photoFilterId }
            });
            return response.data.data; // true: 중복됨, false: 사용 가능
        } catch (error) {
            console.error('필터 중복 체크 실패:', error);
            throw error;
        }
    }
};

export default themeFilterMappingApi;